<template>
  <div class="tr-container" :style="{'height':height,'width':width}" :class="className">
    <slot name="title">
      <div class="tr-container-title">
        <p class="title">
          <span class="title-greenball"></span>{{this.title}}</p>
        <div class="title-image"></div>
      </div>
    </slot>
    <slot></slot>
  </div>
</template>
<script>
export default {
  data(){
    return {}
  },
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    title: {
      type: String
    },
    className: {
      type: String
    },
    titleInfoClassName: {
      type: String,
      default: ""
    },
    titleImageUrl: {
      type:String
    }
  }
}
</script>
<style lang="less">
  .tr-container{
    .tr-container-title{
      padding:15px 15px 0px;
      .title{
        text-align: left;
        margin:0;
        font-size: 20px;
        font-weight: 500;
        .title-greenball{
          display: inline-block;
          height:10px;
          width:10px;
          border-radius: 5px;
          background: #57dec1;
          margin-right: 10px;
        }
      }
    }
    .title-image{
      height:32px;
      background-image: url('~@/assets/title-image.png')
    }
  }
</style>